
import { LANGUAGE } from '../../constants/localStorage';
import { getData } from '../../services/storage';

import React from 'react';
import { debounce } from '../../utils/helpers';
import { PickupPoints, FilterOption } from '../../types/pickup-points';
import { usePickupPoints } from '../../hooks/usePickupPoints';

interface FilterButtonsProps {
  filterOption: FilterOption;
  setFilterOption: (option: FilterOption) => void;
  locale: string;
}

export const FilterButtons: React.FC<FilterButtonsProps> = ({ filterOption, setFilterOption, locale }) => {
  return (
    <div className="mb-4 flex flex-wrap justify-center space-x-2 gap-3">
      <button
        className={`px-4 py-2 rounded-md transition-colors ${filterOption === 'insideDhaka' ? 'bg-[#e9be5a] text-white' : 'bg-[#081939] text-gray-200'}`}
        onClick={() => setFilterOption('insideDhaka')}
      >
        {locale === 'en' ? 'Inside Dhaka' : 'ঢাকার মধ্যে'}
      </button>
      <button
        className={`px-4 py-2 rounded-md transition-colors ${filterOption === 'wholeCountry' ? 'bg-[#e9be5a] text-white' : 'bg-[#081939] text-gray-200'}`}
        onClick={() => setFilterOption('wholeCountry')}
      >
        {locale === 'en' ? 'Whole Country' : 'সম্পূর্ণ দেশ'}
      </button>
    </div>
  );
};


interface SearchInputProps {
  onSearch: (term: string) => void;
  locale: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({ onSearch, locale }) => {
  const handleSearch = debounce((term: string) => {
    onSearch(term);
  }, 300);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    handleSearch(value);
  };

  return (
    <div className="mb-4">
      <input
        type="text"
        placeholder={locale === 'en' ? 'Search pick up locations near you' : 'পিক-আপ লোকেশন খুজুন'}
        onChange={handleSearchChange}
        className="border px-4 py-2 w-64 md:w-96 rounded focus:outline-none focus:ring-1 focus:ring-[#e9be5a] focus:border-[#e9be5a]"
      />
    </div>
  );
};


interface PickupPointsTableProps {
  points: PickupPoints[];
  loading: boolean;
  locale: string;
}

export const PickupPointsTable: React.FC<PickupPointsTableProps> = ({ points, loading, locale }) => {
  return (
    <div className="overflow-x-auto w-full max-w-4xl">
      <table className="table-auto border-collapse w-full text-left border border-gray-300 mx-auto">
        <thead>
          <tr>
            <th className="border px-4 py-2">{locale === 'en' ? 'District' : 'জেলা'}</th>
            <th className="border px-4 py-2">{locale === 'en' ? 'Branch Name' : 'শাখার নাম'}</th>
            <th className="border px-4 py-2">{locale === 'en' ? 'Pickup Address' : 'পিক-আপ ঠিকানা'}</th>
            <th className="border px-4 py-2">{locale === 'en' ? 'Provider' : 'প্রদানকারী'}</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td className="border px-4 py-2 text-center" colSpan={4}>
                {locale === 'en' ? 'Loading Pick Locations....' : 'পিক-আপ লোকেশন লোড হচ্ছে'}
              </td>
            </tr>
          ) : points.length > 0 ? (
            points.map((point) => (
              <tr key={point.id}>
                <td className="border px-4 py-2">{locale === 'en' ? point.districtEn : point.districtBn}</td>
                <td className="border px-4 py-2">{locale === 'en' ? point.branchEn : point.branchBn}</td>
                <td className="border px-4 py-2">{locale === 'en' ? point.addressEn : point.addressBn}</td>
                <td className="border px-4 py-2">{point.provider}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td className="border px-4 py-2 text-center" colSpan={4}>
                {locale === 'en' ? 'No location found' : 'কোনো ঠিকানা পাওয়া যায় নি'}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};


const PickupPoint = () => {
  const locale = getData(LANGUAGE);
  const { 
    filteredPoints, 
    loading, 
    filterOption, 
    setFilterOption, 
    handleSearchChange 
  } = usePickupPoints();

  console.log(filteredPoints);

  return (
    <div className="flex flex-col items-center p-4">
      <h2 className="text-2xl font-bold mt-20 mb-4">
        {locale === 'en' ? 'Goldkinen - Pickup Points' : 'গোল্ড কিনেন - পিক-আপ পয়েন্টস'}
      </h2>

      {/* Filter Options */}
      <FilterButtons 
        filterOption={filterOption} 
        setFilterOption={setFilterOption} 
        locale={locale} 
      />

      {/* Search */}
      <SearchInput 
        onSearch={handleSearchChange} 
        locale={locale} 
      />

      {/* Table */}
      <PickupPointsTable 
        points={filteredPoints} 
        loading={loading} 
        locale={locale} 
      />
    </div>
  );
};

export default PickupPoint;